export default __webpack_public_path__ + "static/media/2.663edf5d.jpg";